var _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 109,
    viewBox: "0 0 153 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8646 73.3149L28.4196 52.2676L12.9834 38.9676L12.3043 38.387L11.4104 40.0072L12.0895 40.5878L25.6248 52.1753L51.6675 74.4475C52.7356 75.3999 53.389 76.7321 53.4884 78.1596C53.5879 79.5872 53.1254 80.9971 52.1997 82.0884C51.274 83.1797 49.9585 83.866 48.5338 84.0008C47.1092 84.1356 45.6882 83.7082 44.5743 82.8099L7.55195 51.5505L6.51121 50.6711L5.82888 50.0963L5.07698 51.4591L5.75609 52.0398L43.3202 84.3916C44.1468 85.0957 45.1192 85.6078 46.1674 85.8912C47.2157 86.1746 48.3136 86.2221 49.3824 86.0304C50.4512 85.8387 51.4642 85.4125 52.3486 84.7825C53.233 84.1525 53.9668 83.3343 54.4972 82.3868C55.3083 80.9172 55.5888 79.2131 55.2915 77.561C54.9941 75.909 54.1372 74.4096 52.8646 73.3149Z",
    fill: "#A61D12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82375 50.1336L6.52364 50.6775L7.56438 51.5569L44.575 82.8099C45.689 83.7082 47.1099 84.1356 48.5346 84.0008C49.9592 83.866 51.2748 83.1797 52.2004 82.0884C53.1261 80.9971 53.5886 79.5872 53.4892 78.1596C53.3897 76.7321 52.7363 75.3999 51.6683 74.4474L25.6287 52.1694L12.0935 40.582L6.82375 50.1336Z",
    fill: "#F7F7F7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2397 74.8985L52.8639 73.3149C54.0018 74.2937 54.8106 75.599 55.1806 77.0535C55.5507 78.5081 55.4639 80.0412 54.9321 81.4447C54.4003 82.8482 53.4493 84.0539 52.2083 84.8981C50.9673 85.7422 49.4966 86.1837 47.9958 86.1627L94.0101 87.7376L94.1231 87.7542C95.6453 87.8273 97.1523 87.4231 98.4336 86.5981C99.715 85.7732 100.707 84.5686 101.27 83.1527C101.834 81.7368 101.941 80.1802 101.577 78.7004C101.213 77.2205 100.396 75.8914 99.2397 74.8985Z",
    fill: "url(#paint0_linear_510_2811)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3076 38.3811L12.9867 38.9618L28.423 52.2618L52.8647 73.315L99.2404 74.8985L58.6801 39.9705L13.2901 38.412L12.3076 38.3811Z",
    fill: "url(#paint1_linear_510_2811)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9633 40.2007C34.9353 40.2468 34.9123 40.2958 34.8949 40.3468C33.4599 44.0098 49.593 53.8452 70.94 62.2926C91.7623 70.5201 109.843 74.3872 112.043 71.1541C112.08 71.1084 112.11 71.0576 112.133 71.0034L112.203 70.8202C112.697 69.0287 109.349 65.9095 103.442 62.2288C96.8955 58.1599 87.2104 53.4031 76.1208 49.0216C68.0068 45.7341 59.6839 42.9945 51.2074 40.821C42.2226 38.6507 36.0109 38.2747 34.9633 40.2007Z",
    fill: "url(#paint2_linear_510_2811)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.455 62.1603C109.361 65.841 112.705 68.96 112.215 70.7517L116.3 59.4475L119.302 51.2085C119.302 51.2085 106.332 37.5848 83.1609 28.5327C59.9903 19.4806 42.9244 22.7727 42.9244 22.7727L41.6976 25.451L34.9472 40.2002C35.9948 38.2741 42.2065 38.6502 51.1755 40.8199C59.6565 42.9704 67.9855 45.6871 76.1071 48.9522C87.2221 53.3611 96.9081 58.0914 103.455 62.1603Z",
    fill: "url(#paint3_linear_510_2811)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1313 0.321174C19.2009 0.212721 18.6454 1.32817 19.2925 2.00533L41.6977 25.451L42.9245 22.7727C42.9245 22.7727 59.9853 19.4751 83.161 28.5327C106.337 37.5903 119.302 51.2085 119.302 51.2085L116.315 59.448L147.963 60.5532C148.89 60.5856 149.358 59.4472 148.676 58.8184L95.8116 10.1055C95.0349 9.38971 94.0515 8.93833 93.0024 8.81603L20.1313 0.321174Z",
    fill: "url(#paint4_linear_510_2811)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.292 31.807C119.796 32.3118 119.721 32.1782 119.796 32.3118C123.331 34.8362 131.095 43.8133 127.039 61.2303C124.928 70.2984 127.199 76.2131 131.061 79.8605C134.868 83.4569 140.098 84.7295 143.744 84.8183C144.17 84.8287 144.525 84.4916 144.535 84.0654C144.545 83.6393 144.208 83.2854 143.781 83.275C140.386 83.1923 135.57 81.9949 132.122 78.7388C128.729 75.5337 126.535 70.2134 128.545 61.58C132.732 43.5939 125.078 33.9937 120.442 31.4006C119.927 31.0261 118.522 31.0756 118.787 31.3021C119.051 31.5286 119.292 31.807 119.292 31.807Z",
    fill: "#2F2CC0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_510_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.16 88.6717L139.131 86.648C137.669 86.1571 136.903 84.553 137.442 83.1075C137.933 81.7878 139.348 81.0585 140.708 81.4237L146.91 83.0891C147.265 83.1846 147.467 83.5593 147.351 83.9087L145.897 88.3033C145.796 88.6089 145.465 88.7741 145.16 88.6717Z",
    fill: "url(#paint5_linear_510_2811)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.5417,
    ry: 3.0834,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 146.109 85.9187)",
    fill: "url(#paint6_linear_510_2811)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_510_2811",
    x: 6.52344,
    y: 40.582,
    width: 46.9785,
    height: 47.4432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_510_2811",
    result: "effect2_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_510_2811",
    x: 12.3086,
    y: 38.3811,
    width: 86.9316,
    height: 36.5174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_510_2811",
    x: 34.8066,
    y: 38.9521,
    width: 77.4434,
    height: 33.3408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_510_2811",
    result: "effect2_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_510_2811",
    x: 34.9473,
    y: 22.189,
    width: 84.3535,
    height: 52.5627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_510_2811",
    result: "effect2_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_510_2811",
    x: 19.0117,
    y: 0.313812,
    width: 129.988,
    height: 60.2401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.172549 0 0 0 0 0.47451 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_510_2811",
    x: 118.754,
    y: 31.1256,
    width: 25.7812,
    height: 54.6929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_510_2811",
    x: 137.27,
    y: 81.3298,
    width: 10.1152,
    height: 7.37221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_2811"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_510_2811",
    result: "effect2_innerShadow_510_2811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_2811",
    x1: 70.9904,
    y1: 69.7646,
    x2: 69.7064,
    y2: 94.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#E94134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FF7A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#A61D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_2811",
    x1: 14.9265,
    y1: 68.0527,
    x2: 91.9619,
    y2: 40.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73C30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_2811",
    x1: 73.8662,
    y1: 48.7891,
    x2: 61.027,
    y2: 78.3193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2155D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_2811",
    x1: 19.0852,
    y1: 41.9415,
    x2: 126.079,
    y2: 81.3151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#91EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1941A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_2811",
    x1: 93.9808,
    y1: 0.00000546758,
    x2: 71.2982,
    y2: 71.8997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A7ACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1941A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_2811",
    x1: 142.011,
    y1: 80.7795,
    x2: 142.011,
    y2: 88.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD776D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0382D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_510_2811",
    x1: 1.5417,
    y1: 0,
    x2: 1.5417,
    y2: 6.16681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF584E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIcon);
export default __webpack_public_path__ + "static/media/StudyIcon.16214a2e9bf737ec2e7f6e0337d07ba4.svg";
export { ForwardRef as ReactComponent };